import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AssetlinksService } from 'src/app/services/assetlinks.service';
import { CampaignLoyaltyProgramme, IndefiniteLoyaltyProgramme, Outlet, OutletWithDealz } from 'src/app/models/interfaces';
import { GisService } from 'src/app/services/gis.service';
import { LocationService } from 'src/app/services/location.service';
import { SwiperComponent } from 'swiper/angular';
import SwiperCore, { SwiperOptions, Virtual,Pagination,EffectCards,Scrollbar, EffectFlip  } from 'swiper';
import { OutletPage } from 'src/app/pages/outlet/outlet.page';
import { DateTimeService } from 'src/app/services/date-time.service';
import { ToastServiceService } from 'src/app/services/toast-service.service';
// install Swiper modules
SwiperCore.use([Scrollbar]);

@Component({
  selector: 'app-outlet-lane',
  templateUrl: './outlet-lane.component.html',
  styleUrls: ['./outlet-lane.component.scss'],
})
export class OultetLaneComponent  implements OnInit {
  @Input() outlet:Outlet
  @Input() itemHeight = '100px'
  @Input() mode:'dealSelect'|'loyaltyJoin'='loyaltyJoin'
  @Output() onDealSelectEmit:EventEmitter<CampaignLoyaltyProgramme | IndefiniteLoyaltyProgramme> = new EventEmitter();
  @Input() kmFromUser:number | undefined
  @ViewChild('swiper', { static: true }) swiper?: SwiperComponent;
  swiperConfig: SwiperOptions = {
    slidesPerView:'auto',
    centeredSlides:true,
    centeredSlidesBounds:true,
    scrollbar:true,
    // cardsEffect:{
    //   slideShadows:false,
    //   // transformEl:'ion-card'
    // },
    flipEffect:{
      transformEl:'ion-card'
    }
  };
  constructor(
    public assetLinksService:AssetlinksService,
    private modalCtrl:ModalController,
    private gisService:GisService,
    private dateTimeService:DateTimeService,
    private locationService:LocationService,
    private toasts:ToastServiceService
  ) { 
   
 
  }

  ngOnInit() {}

  dealSelected(deal){
    this.onDealSelectEmit.emit(deal);
    console.log('emitted from OultetLaneComponent',deal);
  }

  onSwiper(params) {
    const [swiper] = params;
    console.log(swiper);
  }
  
  onBeforeTransitionStart(params) {
    const [swiper, speed, internal] = params;
    console.log('beforeTransitionStart, speed: ' + speed);
  }
  
  onSlideChange() {
    console.log('slide change');
  }
  
  slideNext(){
    this.swiper.swiperRef.slideNext(500);
  }
  
  slidePrev(){
   this.swiper.swiperRef.slidePrev(500);
  }

  calcKmFromOultet(){
  // if(this.locationService.isUserLocationSet()){
  //   let kmFromSpecial = this.gisService.getDistanceFromLocation(
  //     this.outlet.lng,
  //     this.outlet.lat,
  //     {
  //       lng:this.locationService.userLocation.lng,
  //       lat:this.locationService.userLocation.lat
  //     }
  //   )
  //   console.log(  {
  //     lng:this.locationService.userLocation.lng,
  //     lat:this.locationService.userLocation.lat
  //   });
    // if(this.outlet['kmFromSpecial']){
    //   let kmFromSpecialStr = this.outlet['kmFromSpecial'].toFixed(2);
    //   return kmFromSpecialStr
    // }else{
    //   return null
    // }

  //}
  }


  async viewAction(){
    try {
      const modal = await this.modalCtrl.create({
        component: OutletPage,
        mode: 'ios',
        initialBreakpoint: 1,
        breakpoints: [0, 1],
        handle:false,
        componentProps: {
          outlet:this.outlet,
          today:this.dateTimeService.giveLocalNowDay()
        }
      });
      await modal.present();
    } catch (error) {
      console.error(error)
    }
  }

}
